import axios from 'axios';

export default class SnoozeService {
  static getUserOptions(name) {
    return axios({
      method: 'post',
      url: '/p/oneapp/client/api/getUserOptions',
      data: {
        optionNames: [name],
      },
    })
      .then(({ data }) => {
        if (data.code === 200) {
          const matched = data.userOptions.filter(
            (x) => x.optionName === name,
          )[0];
          return matched && matched.optionValue;
        }
      })
      .catch(() => {});
  }

  static setSnooze(option) {
    return axios({
      method: 'post',
      url: '/p/oneapp/client/api/setSnooze',
      data: option,
    }).then(({ data }) => data);
  }
}
